module.exports = __webpack_public_path__ + "static/media/hizalMockup.cf85299c.jpg";